<template>
  <v-menu
    v-model="timePickerOpen"
    :max-width="260"
    :min-width="260"
    :close-on-content-click="false"
    content-class="UXDatapicker"
    :disabled="dis"
  >
    <template v-slot:activator="{ on }">
      <div class="UXdatetimeInput outline" :class="{disabled: dis}" v-on="on">
        <span v-if="isTimeValue">{{ hour ? hour : '00' }}:{{ minute ? minute : '00' }}</span>
        <span v-else-if="isHourValue">{{ hour ? hour : '00'}}時間 {{ minute ? minute : '00'}}分</span>
        <span v-else>{{ hour ? hour : '00' }}:{{ minute ? minute : '00' }}</span>
        <input type="hidden" v-model="value" />
        <i class="UXicon-down"></i>
      </div>
    </template>
    <v-card class="UXdtpCard">
      <div class="head">
        <p>
          <strong>
            <span v-if="hour || minute">
              <span v-if="isTimeValue">{{hour ? hour + ':' : ''}}</span>
              <span v-else-if="isHourValue">{{hour ? hour + '時間 ' : ''}}</span>
              {{minute ? minute : ''}}
            </span>
            <span v-else>時間選択</span>
          </strong>
        </p>
        <div class="endBtn" v-if="hour && minute">
          <v-btn dark color="#ff8c8c" @click="setTime">完了</v-btn>
        </div>
      </div>
      <div class="con2">
        <div class="timeBoxHeader">配信時間</div>
        <div class="timeBox">
          <dl>
            <dd>
              <perfect-scrollbar>
                <ul>
                  <li v-for="(item, index) in hours" :key="index">
                    <a v-if="isTimeValue" :class="{on : hour === item}" @click="hour = item; setClickTime()">{{item}}時</a>
                    <a v-else-if="isHourValue" :class="{on : hour === item}" @click="hour = item">{{item}}時間</a>
                  </li>
                </ul>
              </perfect-scrollbar>
            </dd>
          </dl>
          <dl>
            <dd>
              <perfect-scrollbar>
                <ul v-if="!(hour === 24 || hour === '24')">
                  <li v-for="(item, index) in minutes" :key="index">
                    <a :class="{on: minute == item}" @click="minute = item ;setClickTime()">{{ item }}分</a>
                  </li>
                </ul>
                <ul v-else>
                  <li>
                    <a :class="{on: minute == '00'}" @click="minute = '00'">00分</a>
                  </li>
                </ul>
              </perfect-scrollbar>
            </dd>
          </dl>
        </div>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: 'TimePicker',
  data () {
    return {
      timePickerOpen: false,
      hours: [],
      minutes: [],
      hour: '',
      minute: ''
    }
  },
  props: {
    value: {
      type: String,
      required: false
    },
    minuteScope: {
      type: Number,
      required: false
    },
    isOutline: {
      type: Boolean,
      default: false,
      required: false
    },
    maxHour: {
      type: Number,
      required: false
    },
    isTimeValue: {
      // '00시' 표기
      type: Boolean,
      default: true,
      required: true
    },
    isHourValue: {
      // '00시간' 표기
      type: Boolean,
      default: false,
      required: false
    },
    dis: {
      type: Boolean
    }
  },
  created () {
    const minuteScopeNum = !this.minuteScope ? 5 : this.minuteScope < 60 ? this.minuteScope : 5
    const maxHour = !this.maxHour ? 24 : this.maxHour < 25 ? this.maxHour : 24
    for (let i = 0; i < 60; i++) {
      let num = i.toString().length > 1 ? i : '0' + i.toString()
      if (this.hours.length <= maxHour && i >= 0) {
        this.hours.push(num)
      }
      if (i % minuteScopeNum === 0) {
        this.minutes.push(num)
      }
    }
    setTimeout(() => {
      this.resetTime()
    }, 50)
  },
  watch: {
    timePickerOpen (val) {
      this.resetTime()
    },
    value (val) {
      this.resetTime()
    }
  },
  methods: {
    resetTime () {
      if (this.value) {
        let time = this.value.split(':')
        this.hour = time[0]
        this.minute = time[1]
      }
    },
    setTime () {
      this.$emit('input', this.hour + ':' + this.minute)
      this.timePickerOpen = false
    },
    setClickTime () {
      this.$emit('input', this.hour + ':' + this.minute)
    },
    resetTimePicker (start, end) {
      this.hour = start
      this.minute = end
    }
  }
}
</script>

<style lang="scss">
  .timeBoxHeader {
    text-align: center;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/TimePicker.vue